export default {
  mainRouter: 'main',
  inviteRouter: 'convite',
  rechargeRouter: 'recharge',
};
